app.service('evidenceManagementService', function ($http) {


  // Evidence (Photos, Repairs, notes) Routes |---------------------------------------------------
  this.getAllEvidence = function (obj) {
    return $http.post(`/evidence/getAllEvidence`, obj)
      .then(function (response) {
        return response
      })
  }

  this.getEvidenceRecord = function (obj) {
    return $http.post(`/evidence/getEvidenceRecord`, obj)
      .then(function (response) {
        return response
      })
  }

  this.saveEvidenceRecord = function (obj) {
    return $http.post(`/evidence/saveEvidenceRecord`, obj)
      .then(function (response) {
        return response
      })
  }
  //----------------------------------------------------------------------------------------------




  // Evidence (Documents) Routes |---------------------------------------------------
  this.getAllDocuments = function (obj) {
    return $http.post(`/evidence/getAllDocuments`, obj)
      .then(function (response) {
        return response
      })
  }
  this.saveDocumentsRecord = function (obj) {
    return $http.post(`/evidence/saveDocumentsRecord`, obj)
      .then(function (response) {
        return response
      })
  }
  //----------------------------------------------------------------------------------------------

})